import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { useAuthStore } from '../store/authStore';
import { assetPath } from '../lib/paths';
import { Navigate } from 'react-router-dom';

export function LoginPage() {
  const { user, signInWithGoogle, error } = useAuthStore();

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30">
      <Card className="w-[400px]">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <img src={assetPath('AI-CoE-Icon.svg')} alt="AI CoE Portal" className="h-14 w-14" />
          </div>
          <CardTitle className="text-2xl">AI CoE Portal</CardTitle>
          <CardDescription>
            Submit and track AI project proposals for committee review.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <p className="text-sm text-destructive text-center">{error}</p>
          )}
          <Button className="w-full" onClick={signInWithGoogle}>
            Sign in with Google
          </Button>
          <p className="text-xs text-muted-foreground text-center">
            Only @iqm.com emails are allowed.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
